import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

import type { EditorButton, EditorButtonsGroup } from '@core/prosemirror-legacy';

@Injectable()
export class ToolbarService {
  public contextButtons$: Observable<EditorButton[]>;
  public rightOutletButtons$: Observable<EditorButton[]>;
  public leftOutletButtons$: Observable<EditorButtonsGroup[]>;
  public moreOutletButtons$: Observable<EditorButton[]>;

  private buttons: {
    context: EditorButton[];
    left: EditorButtonsGroup[];
    right: EditorButton[];
    more: EditorButton[];
  } = {
    context: [],
    left: [],
    right: [],
    more: [],
  };
  private additionalButtons: EditorButton[] = [];
  private contextButtons = new BehaviorSubject<EditorButton[]>([]);
  private rightOutletButtons = new BehaviorSubject<EditorButton[]>([]);
  private leftOutletButtons = new BehaviorSubject<EditorButtonsGroup[]>([]);
  private moreOutletButtons = new BehaviorSubject<EditorButton[]>([]);

  constructor() {
    this.contextButtons$ = this.contextButtons.asObservable();
    this.rightOutletButtons$ = this.rightOutletButtons.asObservable();
    this.leftOutletButtons$ = this.leftOutletButtons.asObservable();
    this.moreOutletButtons$ = this.moreOutletButtons.asObservable();
  }

  public setContextButtons(context: EditorButton[]) {
    this.buttons = { ...this.buttons, context };
    this.contextButtons.next(context);
  }

  public setLeftButtons(left: EditorButtonsGroup[]) {
    this.buttons = { ...this.buttons, left };
    this.leftOutletButtons.next(left);
  }

  public setRightButtons(right: EditorButton[]) {
    this.buttons = { ...this.buttons, right };
    this.rightOutletButtons.next([...this.additionalButtons, ...right]);
  }

  public setMoreButtons(more: EditorButton[]) {
    this.buttons = { ...this.buttons, more };
    this.moreOutletButtons.next(more);
  }

  public setAdditionalButtons(buttons: EditorButton[]) {
    this.additionalButtons = buttons;
    this.rightOutletButtons.next([...buttons, ...this.buttons.right]);
  }
}
